import { render, staticRenderFns } from "./custoMer.vue?vue&type=template&id=6e3353dd&scoped=true&"
import script from "./custoMer.vue?vue&type=script&lang=js&"
export * from "./custoMer.vue?vue&type=script&lang=js&"
import style0 from "./custoMer.vue?vue&type=style&index=0&id=6e3353dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3353dd",
  null
  
)

export default component.exports